import { render, staticRenderFns } from "./AttachDealerAccountAction.vue?vue&type=template&id=33e8eb4d&scoped=true&"
import script from "./AttachDealerAccountAction.vue?vue&type=script&lang=ts&"
export * from "./AttachDealerAccountAction.vue?vue&type=script&lang=ts&"
import style0 from "./AttachDealerAccountAction.vue?vue&type=style&index=0&id=33e8eb4d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e8eb4d",
  null
  
)

export default component.exports